<ng-content></ng-content>


// WEBPACK FOOTER //
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/@angular/material/icon/typings/index.d.ts.MatIcon.html